(function () {
  'use strict';

  if (!location.pathname.startsWith('/a/subscriptions/manage/')) return;

  var PROXY_URL = 'https://grns-insights-hub.vercel.app/api/seal-proxy';

  var ADDONS = [
    {
      key: 'tub',
      product_id: '7123550961745',
      title: 'GRNS Daily Super Greens',
      price: 68.50,
      comparePrice: 85.00,
      quantity: 1,
      label: 'Daily Tub',
      detail: '250g · 30 serves',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/122.webp?v=1778896174',
      defaultOneTime: false,
      variants: [
        { label: 'Natural', variant_id: '59228685172817', sku: 'GRN-GP-250-ORG-1', title: 'GRNS Natural' },
        { label: 'Mango', variant_id: '59228685205585', sku: 'GRN-GP-250-MP-2', title: 'GRNS Mango/Passionfruit' }
      ]
    },
    {
      key: 'daily_sachet',
      product_id: '15703678091345',
      title: 'Daily Sachets',
      price: 99.95,
      comparePrice: null,
      quantity: 1,
      label: 'Daily Sachets',
      detail: '30-pack',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/Nutritional_Label_72.webp?v=1771545403',
      defaultOneTime: true,
      variants: [
        { label: 'Natural', variant_id: '59228704735313', sku: 'GRNS TRVL 30 NAT', title: 'GRNS Natural Daily Sachets' },
        { label: 'Mango', variant_id: '59228704768081', sku: 'GRNS TRVL 30 NAT-2', title: 'GRNS Mango/Passionfruit Daily Sachets' }
      ]
    },
    {
      key: 'sachet',
      product_id: '7774652006481',
      title: 'Travel Sachets',
      price: 7.99,
      comparePrice: 19.99,
      quantity: 1,
      label: 'Travel Sachets',
      detail: '2× pack',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/gempages_489095260442461323-54515ca1-fbd7-4c5f-bfe6-7f048251e639.webp?v=1747866450',
      defaultOneTime: true,
      variants: [
        { label: 'Natural', variant_id: '59228793405521', sku: 'GRN-SACHET', title: 'GRNS Natural Sachets' },
        { label: 'Mango', variant_id: '59228793438289', sku: 'GRN-SACHET-2', title: 'GRNS Mango/Passionfruit Sachets' }
      ]
    },
    {
      key: 'bottle',
      product_id: '7774651711569',
      variant_id: '42398899601489',
      title: 'Premium Glass Bottle',
      sku: 'GRN-BOTTLE',
      price: 19.99,
      comparePrice: 29.99,
      quantity: 1,
      label: 'Glass Bottle',
      detail: '500ml',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/GRNS_169_ads_1080_x_1080_px_29.webp?v=1771737940',
      defaultOneTime: true
    },
    {
      key: 'tumbler',
      product_id: '15570902384721',
      variant_id: '58283630690385',
      title: 'Travel Tumbler (Free Shipping)',
      sku: 'DPGRNTUMBLER',
      price: 34.99,
      comparePrice: 39.99,
      quantity: 1,
      label: 'Travel Tumbler',
      detail: '40oz',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/Nutritional_Label_53.webp?v=1767417812',
      defaultOneTime: true
    },
    {
      key: 'spoon',
      product_id: '15732349435985',
      variant_id: '59228861923409',
      title: 'Metal Scoop',
      sku: 'SPOON-MET',
      price: 3.99,
      comparePrice: 4.99,
      quantity: 1,
      label: 'Metal Scoop',
      detail: 'Stainless steel',
      image: 'https://cdn.shopify.com/s/files/1/0572/1253/4865/files/NutritionalLabel_7.webp?v=1774319376',
      defaultOneTime: true
    }
  ];

  function preloadImages() {
    ADDONS.forEach(function(a) {
      var img = new Image();
      img.src = a.image;
    });
  }

  /* Shared sub-info cache used by upsell cards (currency conversion + discount adjustment)
     AND Klaviyo tracking. One check-phone fetch per page load, reused everywhere.
     Returns: { email, currency, fx_rate (AUD→currency), discount_pct, interval, plan_name } */
  var SUB_INFO_URL = 'https://grns-insights-hub.vercel.app/api/seal-proxy?mode=check-phone';
  var _subInfoPromise = null;
  function fetchSubInfo() {
    if (_subInfoPromise) return _subInfoPromise;
    var subId = getSubscriptionId();
    if (!subId) { _subInfoPromise = Promise.resolve({}); return _subInfoPromise; }
    _subInfoPromise = fetch(SUB_INFO_URL + '&id=' + subId)
      .then(function (r) { return r.json(); })
      .catch(function () { return {}; });
    return _subInfoPromise;
  }

  /* Currency helpers. Given an AUD amount, return the customer's local-currency amount + formatted string. */
  function convertAud(amountAud, info) {
    var rate = (info && info.fx_rate) ? Number(info.fx_rate) : 1;
    return amountAud * rate;
  }
  function formatPrice(amountAud, info) {
    var ccy = (info && info.currency) ? String(info.currency).toUpperCase() : 'AUD';
    var amount = convertAud(amountAud, info);
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: ccy, maximumFractionDigits: 2 }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }
  /* Repaint all rendered addon-card prices once subInfo resolves. Called after fetch completes. */
  function repaintAddonPrices(info) {
    var cards = document.querySelectorAll('.grns-addon-card');
    cards.forEach(function (card) {
      var priceEl = card.querySelector('.grns-addon-card__price');
      if (!priceEl) return;
      var aud = parseFloat(priceEl.getAttribute('data-addon-aud') || '0');
      var compareAud = parseFloat(priceEl.getAttribute('data-addon-compare-aud') || '0');
      if (aud <= 0) return;
      var main = formatPrice(aud, info);
      var html = main;
      if (compareAud > aud) {
        html += '<span class="grns-addon-card__compare">' + formatPrice(compareAud, info) + '</span>';
      }
      priceEl.innerHTML = html;
    });
  }

  /* Seal moved the customer portal from /manage/{base36_id} to /a/subscriptions/... — extract
     the subscription ID from whatever pattern is live, falling through candidates. Real Seal IDs
     are ~8-digit integers (e.g. 14510199); base36 encodings are 4-6 chars (e.g. "8n053"). */
  function getSubscriptionId() {
    var parts = location.pathname.split('/');
    /* 1. Legacy: /manage/{base36_id} */
    var idx = parts.indexOf('manage');
    if (idx !== -1 && parts[idx + 1]) {
      var n = parseInt(parts[idx + 1], 36);
      if (n && n > 1e6 && n < 1e10) return n;
    }
    /* 2. Numeric ID directly in path — /a/subscriptions/subscriptions/14510199, /account/subscriptions/14510199, etc. */
    for (var i = 0; i < parts.length; i++) {
      if (/^\d{7,10}$/.test(parts[i])) {
        var num = parseInt(parts[i], 10);
        if (num > 1e6 && num < 1e10) return num;
      }
    }
    /* 3. Base36 ID somewhere in path — /apps/subscriptions/8n053/... variants */
    for (var i = 0; i < parts.length; i++) {
      var seg = parts[i];
      if (/^[0-9a-z]{4,7}$/i.test(seg) && !/^\d+$/.test(seg)) {
        var n2 = parseInt(seg, 36);
        if (n2 > 1e6 && n2 < 1e10) return n2;
      }
    }
    /* 4. Query string — ?id=12345678 or ?subscription_id=... */
    try {
      var q = new URLSearchParams(location.search);
      var qid = q.get('subscription_id') || q.get('id');
      if (qid) {
        var n3 = parseInt(qid, 10) || parseInt(qid, 36);
        if (n3 > 1e6 && n3 < 1e10) return n3;
      }
    } catch (e) {}
    /* 5. Data attribute on DOM (Seal often adds this) */
    var dataEl = document.querySelector('[data-subscription-id],[data-sub-id],[data-seal-subscription]');
    if (dataEl) {
      var v = dataEl.getAttribute('data-subscription-id') || dataEl.getAttribute('data-sub-id') || dataEl.getAttribute('data-seal-subscription');
      var n4 = parseInt(v, 10);
      if (n4 > 1e6 && n4 < 1e10) return n4;
    }
    /* 6. Hidden input */
    var input = document.querySelector('input[name="subscription_id"], input[name="id"][type="hidden"]');
    if (input && input.value) {
      var n5 = parseInt(input.value, 10);
      if (n5 > 1e6 && n5 < 1e10) return n5;
    }
    /* 7. Scan any link/form on the page for a subscription ID pattern */
    var links = document.querySelectorAll('a[href*="subscription"], form[action*="subscription"]');
    for (var j = 0; j < links.length; j++) {
      var href = links[j].getAttribute('href') || links[j].getAttribute('action') || '';
      var m = href.match(/\/(\d{7,10})(?:\/|\?|$|#)/);
      if (m) {
        var n6 = parseInt(m[1], 10);
        if (n6 > 1e6 && n6 < 1e10) return n6;
      }
    }
    /* 8. Common Seal globals */
    if (window.SEAL_SUBSCRIPTION_ID) return parseInt(window.SEAL_SUBSCRIPTION_ID, 10);
    if (window.sealsubscription_id) return parseInt(window.sealsubscription_id, 10);
    return null;
  }

  function normalisePhone(raw) {
    var s = String(raw || '').replace(/[^\d+]/g, '');
    if (/^\+?61[2-9]\d{8}$/.test(s)) return s;
    if (/^0[2-9]\d{8}$/.test(s)) return s;
    return '';
  }

  function promptForPhone() {
    var raw = window.prompt(
      'To add items to your next renewal, please enter your phone number:',
      ''
    );
    if (raw === null) return null;
    var clean = normalisePhone(raw);
    if (!clean) {
      window.alert('That doesn’t look like a valid Australian phone number. Please try again with a 10-digit mobile (e.g. 0412 345 678).');
      return promptForPhone();
    }
    return clean;
  }

  function sendAdd(subId, addon, variantId, sku, title, isOneTime, phone, subInfo) {
    /* Convert AUD price → sub currency using fx_rate (Seal charges in the sub's currency, not AUD).
       No discount inflation needed: Seal does NOT apply the sub's loyalty discount to newly-added
       upsell items (verified — Seal's portal shows no discount line on items added via add_items).
       So the customer pays exactly what the card advertises: full member price in their currency. */
    var rate = (subInfo && Number(subInfo.fx_rate)) || 1;
    var adjustedPrice = +(addon.price * rate).toFixed(2);
    var body = {
      id: subId,
      action: 'add_items',
      add_items: [{
        product_id: addon.product_id,
        variant_id: variantId,
        quantity: addon.quantity,
        title: title,
        sku: sku,
        price: adjustedPrice,
        taxable: 1,
        requires_shipping: 0,
        one_time: isOneTime ? 1 : 0,
        properties: []
      }]
    };
    if (phone) body._phone = phone;
    return fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function doAdd(addon, variantId, sku, title, isOneTime, btn, card) {
    var subId = getSubscriptionId();
    if (!subId) {
      console.error('[GRNS portal-addon] Could not resolve subscription ID from URL:', location.pathname);
      btn.textContent = 'Error — refresh';
      setTimeout(function () { btn.textContent = 'Add'; }, 2500);
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Adding';
    btn.classList.add('grns-addon-card__btn--loading');

    /* Center overlay so users know something is happening during Seal's slow add */
    var overlay = document.createElement('div');
    overlay.textContent = 'Adding…';
    overlay.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#19440a;color:#fff;padding:14px 28px;border-radius:12px;font-weight:600;font-size:16px;z-index:99999;box-shadow:0 6px 24px rgba(0,0,0,0.35);';
    document.body.appendChild(overlay);

    function resetBtn() {
      btn.disabled = false;
      btn.textContent = 'Add';
      btn.classList.remove('grns-addon-card__btn--loading');
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }

    function onSuccess() {
      btn.classList.remove('grns-addon-card__btn--loading');
      btn.textContent = 'Added ✓';
      btn.style.background = '#4a7a3a';
      card.classList.add('grns-addon-card--added');
      sessionStorage.setItem('grns_portal_reloading', '1');
      location.reload();
    }

    /* Fetch sub info first (currency + discount_pct) so sendAdd can inflate price when needed. */
    fetchSubInfo().then(function (subInfo) {
      sendAdd(subId, addon, variantId, sku, title, isOneTime, null, subInfo)
        .then(function (data) {
          if (data && data.needs_phone) {
            resetBtn();
            var phone = promptForPhone();
            if (!phone) return;
            btn.disabled = true;
            btn.textContent = 'Adding';
            btn.classList.add('grns-addon-card__btn--loading');
            return sendAdd(subId, addon, variantId, sku, title, isOneTime, phone, subInfo)
              .then(function (retry) {
                if (retry && (retry.error || retry.errors)) {
                  resetBtn();
                  console.error('GRNS addon error:', retry);
                  window.alert('Could not add item. Please try again or contact support@grns.com.au.');
                  return;
                }
                onSuccess();
              });
          }
          if (data && (data.error || data.errors)) {
            resetBtn();
            console.error('GRNS addon error:', data);
            return;
          }
          onSuccess();
        })
        .catch(function (err) {
          resetBtn();
          console.error('GRNS addon error:', err);
        });
    });
  }

  function buildCard(addon) {
    var card = document.createElement('div');
    card.className = 'grns-addon-card';

    var hasVariants = addon.variants && addon.variants.length > 0;
    var oneTimeActive = addon.defaultOneTime !== false;

    var variantsHtml = '';
    if (hasVariants) {
      variantsHtml = '<div class="grns-addon-card__variants">';
      addon.variants.forEach(function(v, i) {
        variantsHtml += '<button class="grns-addon-card__var-btn' + (i === 0 ? ' grns-addon-card__var-btn--active' : '') + '" data-variant-id="' + v.variant_id + '" data-sku="' + v.sku + '" data-title="' + (v.title || '') + '" type="button">' + v.label + '</button>';
      });
      variantsHtml += '</div>';
    }

    /* Store AUD amounts in data attrs so repaintAddonPrices() can update to sub currency
       once we know the customer's currency + FX rate (async fetched from check-phone). */
    var priceInner = '$' + addon.price.toFixed(2) +
      (addon.comparePrice && addon.comparePrice > addon.price
        ? '<span class="grns-addon-card__compare">$' + addon.comparePrice.toFixed(2) + '</span>'
        : '');
    card.innerHTML =
      '<img class="grns-addon-card__img" src="' + addon.image + '" alt="' + addon.label + '">' +
      '<div class="grns-addon-card__info">' +
        '<div class="grns-addon-card__price" data-addon-aud="' + addon.price + '" data-addon-compare-aud="' + (addon.comparePrice || 0) + '">' +
          priceInner +
        '</div>' +
        '<div class="grns-addon-card__label">' + addon.label + ' <span class="grns-addon-card__members">(Members Pricing)</span></div>' +
        '<div class="grns-addon-card__detail">' + addon.detail + '</div>' +
        variantsHtml +
        '<div class="grns-addon-card__freq">' +
          '<button class="grns-addon-card__freq-btn' + (oneTimeActive ? ' grns-addon-card__freq-btn--active' : '') + '" data-onetime="1" type="button">One Time</button>' +
          '<button class="grns-addon-card__freq-btn' + (!oneTimeActive ? ' grns-addon-card__freq-btn--active' : '') + '" data-onetime="0" type="button">Every Renewal</button>' +
        '</div>' +
      '</div>' +
      '<button class="grns-addon-card__btn" type="button">Add</button>';

    if (hasVariants) {
      var varBtns = card.querySelectorAll('.grns-addon-card__var-btn');
      varBtns.forEach(function(vb) {
        vb.addEventListener('click', function() {
          varBtns.forEach(function(b) { b.classList.remove('grns-addon-card__var-btn--active'); });
          vb.classList.add('grns-addon-card__var-btn--active');
        });
      });
    }

    var freqBtns = card.querySelectorAll('.grns-addon-card__freq-btn');
    freqBtns.forEach(function(fb) {
      fb.addEventListener('click', function() {
        freqBtns.forEach(function(b) { b.classList.remove('grns-addon-card__freq-btn--active'); });
        fb.classList.add('grns-addon-card__freq-btn--active');
      });
    });

    var btn = card.querySelector('.grns-addon-card__btn');
    btn.addEventListener('click', function () {
      var activeFreq = card.querySelector('.grns-addon-card__freq-btn--active');
      var isOneTime = activeFreq ? activeFreq.getAttribute('data-onetime') === '1' : true;

      var variantId = addon.variant_id || '';
      var sku = addon.sku || '';
      var title = addon.title || '';
      if (hasVariants) {
        var activeVar = card.querySelector('.grns-addon-card__var-btn--active');
        if (activeVar) {
          variantId = activeVar.getAttribute('data-variant-id');
          sku = activeVar.getAttribute('data-sku');
          title = activeVar.getAttribute('data-title') || title;
        }
      }

      doAdd(addon, variantId, sku, title, isOneTime, btn, card);
    });

    return card;
  }

  function buildImageMap() {
    var map = {};
    ADDONS.forEach(function(addon) {
      if (addon.variants) {
        addon.variants.forEach(function(v) {
          if (v.title) map[v.title.toLowerCase()] = addon.image;
        });
      }
      if (addon.title) map[addon.title.toLowerCase()] = addon.image;
    });
    return map;
  }

  function injectItemImages() {
    var imgMap = buildImageMap();
    /* Cleanup pass: remove any grns-item-img elements that were injected OUTSIDE the Seal
       portal Items container by the previous unscoped version of this function (they end up
       as 2000px images inside the header Shop mega-menu). One-time defensive removal. */
    document.querySelectorAll('.grns-item-img').forEach(function (img) {
      var container = document.getElementById('seal-subscription-items-list-container')
                   || document.getElementById('seal-subscription-items-list');
      if (!container || !container.contains(img)) img.remove();
    });
    /* SCOPE: only search inside the Seal portal's Items list. Previously used document-wide
       search which incorrectly injected 2000px product thumbnails into ANY page element whose
       text matched an addon title — including a Shop mega-menu in the theme header when it
       contained "Daily Sachets" etc. Restrict to the portal container so header + other pages
       are never touched. Silently no-op if the portal container isn't present (any non-portal page). */
    var scope = document.getElementById('seal-subscription-items-list-container')
             || document.getElementById('seal-subscription-items-list');
    if (!scope) return;
    var allEls = scope.querySelectorAll('p, span, div, td, li');
    for (var i = 0; i < allEls.length; i++) {
      var el = allEls[i];
      if (el.children.length > 0) continue;
      var text = el.textContent.trim().toLowerCase();
      var imgSrc = imgMap[text];
      if (!imgSrc) continue;

      var row = el.parentNode;
      for (var j = 0; j < 5; j++) {
        if (!row || row === document.body) { row = null; break; }
        if (row.textContent.indexOf('$') > -1) break;
        row = row.parentNode;
      }
      if (!row || row === document.body) continue;
      if (row.querySelector('.grns-item-img')) continue;

      var checkParent = row.parentNode;
      if (row.querySelector('img') || (checkParent && checkParent.querySelector('img'))) continue;

      var img = document.createElement('img');
      img.className = 'grns-item-img';
      img.src = imgSrc;
      img.alt = el.textContent.trim();
      row.insertBefore(img, row.firstChild);
    }
  }

  function styleOneTimeBadges() {
    var candidates = document.querySelectorAll('span, div, p, label, small');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.children.length === 0 && el.textContent.trim() === 'One-time purchase') {
        el.style.setProperty('background', '#e8f5e2', 'important');
        el.style.setProperty('color', '#2d6a1f', 'important');
        el.style.setProperty('border-color', '#c8e6c0', 'important');
      }
    }
  }

  function hasBaseSubscription() {
    var bodyText = document.body.textContent || '';
    return /single subscription/i.test(bodyText)
        || /double subscription/i.test(bodyText)
        || /90.?day\s+subscription/i.test(bodyText);
  }

  function isBaseSubText(text) {
    var t = (text || '').toLowerCase();
    return t.indexOf('single subscription') !== -1
        || t.indexOf('double subscription') !== -1
        || /90.?day\s+subscription/.test(t);
  }

  function protectBaseSubItems() {
    /* Scan item rows; if a row references the base sub, neutralize any remove/delete control inside it. */
    var rows = document.querySelectorAll('tr, li, [class*="item"], [class*="Item"], [class*="row"]');
    rows.forEach(function (row) {
      if (row.dataset.grnsBaseProtected === '1') return;
      var txt = row.textContent || '';
      if (!isBaseSubText(txt)) return;
      var removeControls = row.querySelectorAll('button, a, [role="button"], [class*="remove" i], [class*="delete" i], [class*="trash" i], svg');
      var protectedAny = false;
      removeControls.forEach(function (el) {
        /* el.className on SVG elements is an SVGAnimatedString (no .toLowerCase); coerce to string */
        var classStr = typeof el.className === 'string' ? el.className : (el.getAttribute && el.getAttribute('class')) || '';
        var label = (el.getAttribute('aria-label') || el.textContent || classStr || '').toString().toLowerCase();
        if (label.indexOf('remove') !== -1 || label.indexOf('delete') !== -1 || label.indexOf('trash') !== -1 || el.classList.contains('seal-remove') || el.classList.contains('seal-delete')) {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          if (el.tagName === 'BUTTON' || el.tagName === 'A') el.setAttribute('disabled', 'disabled');
          protectedAny = true;
        }
      });
      if (protectedAny) row.dataset.grnsBaseProtected = '1';
    });
  }

  /* Limit the Seal product-picker modal to only allow base sub variants.
     Customer should ONLY be able to switch between:
       - Single Subscription - Natural
       - Single Subscription - Mango/Passionfruit
       - Double Subscription - Natural
       - Double Subscription - Mango/Passionfruit
     Everything else (single tubs, flavour combos, welcome kits, etc.) is hidden.
     They can still add tubs/sachets/bottle via our upsell cards, just not via the swap modal. */
  var ALLOWED_PRODUCT_RE = /(single|double)\s+subscription\s*[-–—]?\s*(natural|mango)/i;
  var BLOCKED_PRODUCT_KEYWORDS = [
    'GRNS Daily Super Greens',
    'Daily Super Greens',
    'Welcome Kit',
    'Travel Sachets',
    'Daily Sachets',
    'Glass Bottle',
    'Frother',
    'Spoon',
    'Tumbler',
    'Straw Kit',
    'Recipe E-book'
  ];

  function findRowFromTextNode(el, stopAt) {
    /* Walk up. Return the largest ancestor where:
       - Its textContent does NOT contain a subscription title (so hiding it won't hide allowed products)
       - Its textContent does NOT contain "Select product" or "Find products" headings (so we're not the modal)
       Then it's safe to hide this whole subtree — it's the blocked product's row container. */
    var node = el;
    var safest = null;
    for (var d = 0; d < 12; d++) {
      var parent = node.parentElement;
      if (!parent || parent === stopAt || parent === document.body) break;
      var pText = (parent.textContent || '');
      /* If the PARENT contains a sub title or modal heading, then the current node is the row.
         We've gone as far as we safely can. */
      if (/(single|double)\s+subscription/i.test(pText) || /select\s+a?\s*product|find\s+products/i.test(pText)) {
        safest = node;
        break;
      }
      node = parent;
      safest = node;
      if (pText.length > 5000) break;
    }
    /* Make sure the returned row has $price or button (i.e. it's a real product row, not random) */
    if (safest) {
      var txt = safest.textContent || '';
      if (!/\$\d/.test(txt) && !/\bAdd\b/.test(txt)) return null;
    }
    return safest;
  }

  function filterSwapModal() {
    /* Find the "Select product" modal heading if present */
    var heading = null;
    var candidates = document.querySelectorAll('h1, h2, h3, h4, h5, h6, p, div, span, .modal-title');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.children.length > 0) continue;
      var t = el.textContent.trim().toLowerCase();
      if (t === 'select product' || t === 'select a product') {
        heading = el;
        break;
      }
    }
    if (!heading) return;

    /* The modal is the closest sizable ancestor containing the heading.
       Don't trust class names — just go up a few levels until we find a big enough container. */
    var modal = heading;
    for (var u = 0; u < 8; u++) {
      var p = modal.parentElement;
      if (!p) break;
      modal = p;
      if (modal.children.length >= 3 && (modal.textContent || '').length > 200) break;
    }
    if (!modal || modal === document.body) modal = heading.parentElement;
    if (!modal) return;

    /* Pure block-list: only hide rows whose text contains one of the explicitly disallowed product keywords.
       This is safe (won't accidentally hide allowed sub variants) and covers the actual products we want gone. */
    var leaves = modal.querySelectorAll('*');
    for (var j = 0; j < leaves.length; j++) {
      var le = leaves[j];
      if (le.children.length > 0) continue;
      var txt = (le.textContent || '').trim();
      if (!txt || txt.length > 200) continue;

      var blocked = false;
      for (var k = 0; k < BLOCKED_PRODUCT_KEYWORDS.length; k++) {
        if (txt.indexOf(BLOCKED_PRODUCT_KEYWORDS[k]) !== -1) { blocked = true; break; }
      }
      if (!blocked) continue;

      var row = findRowFromTextNode(le, modal);
      if (!row || row === modal || row === document.body) continue;
      if (row.dataset.grnsSwapHidden) continue;
      /* SAFETY: never hide a container that also contains a subscription title — means we walked too far */
      var rowTxt = row.textContent || '';
      if (/(single|double|90.?day)\s+subscription/i.test(rowTxt)) continue;
      row.style.setProperty('display', 'none', 'important');
      row.dataset.grnsSwapHidden = '1';
    }

    /* Hide the "One-time purchase" button on any subscription option in the
       modal — subs are subscription-only via this flow. Walks text nodes
       matching that phrase and hides the containing button. Idempotent. */
    var mNodes = modal.querySelectorAll('*');
    for (var mn = 0; mn < mNodes.length; mn++) {
      var node = mNodes[mn];
      if (node.children.length > 0) continue;
      var t = (node.textContent || '').trim().toLowerCase();
      if (t !== 'one-time purchase' && t !== 'one time purchase' && t !== 'one-time' && t !== 'one time') continue;
      var btn = node;
      for (var w = 0; w < 4 && btn && btn.parentElement; w++) {
        var bTag = btn.tagName;
        if (bTag === 'BUTTON' || bTag === 'A' || btn.getAttribute('role') === 'button' || /button/i.test(btn.className || '')) break;
        btn = btn.parentElement;
      }
      if (btn && !btn.dataset.grnsOneTimeHidden) {
        btn.style.setProperty('display', 'none', 'important');
        btn.dataset.grnsOneTimeHidden = '1';
      }
    }
  }

  function enhance() {
    styleOneTimeBadges();
    injectItemImages();
    protectBaseSubItems();
    filterSwapModal();
  }

  function cloneWithSync(section) {
    var clone = section.cloneNode(true);

    var origVarBtns = section.querySelectorAll('.grns-addon-card__var-btn');
    var cloneVarBtns = clone.querySelectorAll('.grns-addon-card__var-btn');
    cloneVarBtns.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        origVarBtns[i].click();
        var card = btn.closest('.grns-addon-card');
        card.querySelectorAll('.grns-addon-card__var-btn').forEach(function(b) {
          b.classList.remove('grns-addon-card__var-btn--active');
        });
        btn.classList.add('grns-addon-card__var-btn--active');
      });
    });

    var origFreqBtns = section.querySelectorAll('.grns-addon-card__freq-btn');
    var cloneFreqBtns = clone.querySelectorAll('.grns-addon-card__freq-btn');
    cloneFreqBtns.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        origFreqBtns[i].click();
        var card = btn.closest('.grns-addon-card');
        card.querySelectorAll('.grns-addon-card__freq-btn').forEach(function(b) {
          b.classList.remove('grns-addon-card__freq-btn--active');
        });
        btn.classList.add('grns-addon-card__freq-btn--active');
      });
    });

    var origAddBtns = section.querySelectorAll('.grns-addon-card__btn');
    var cloneAddBtns = clone.querySelectorAll('.grns-addon-card__btn');
    cloneAddBtns.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        var origBtn = origAddBtns[i];
        btn.disabled = true;
        btn.textContent = 'Adding';
        btn.classList.add('grns-addon-card__btn--loading');
        origBtn.click();
        var observer = new MutationObserver(function() {
          if (origBtn.textContent === 'Added ✓') {
            btn.classList.remove('grns-addon-card__btn--loading');
            btn.textContent = 'Added ✓';
            btn.style.background = '#4a7a3a';
            btn.closest('.grns-addon-card').classList.add('grns-addon-card--added');
            observer.disconnect();
          } else if (!origBtn.disabled) {
            btn.disabled = false;
            btn.textContent = 'Add';
            btn.classList.remove('grns-addon-card__btn--loading');
            observer.disconnect();
          }
        });
        observer.observe(origBtn, { attributes: true, childList: true, characterData: true, subtree: true });
      });
    });

    return clone;
  }

  function inject() {
    document.documentElement.classList.remove('grns-portal-loading');
    if (document.querySelector('.grns-addon-section')) return;
    if (!getSubscriptionId()) return;
    /* Only show upsells if a Single Sub or Double Sub exists in this subscription */
    if (!hasBaseSubscription()) return;

    var section = document.createElement('div');
    section.className = 'grns-addon-section grns-addon-section--desktop';

    var heading = document.createElement('p');
    heading.className = 'grns-addon-section__heading';
    heading.textContent = 'Add to next renewal';
    section.appendChild(heading);

    var memberNote = document.createElement('p');
    memberNote.className = 'grns-addon-section__note';
    memberNote.textContent = 'Exclusive member pricing — only available as an add-on to your existing subscription. Not available for one-off purchases.';
    section.appendChild(memberNote);

    var grid = document.createElement('div');
    grid.className = 'grns-addon-grid';
    ADDONS.forEach(function (addon) {
      grid.appendChild(buildCard(addon));
    });
    section.appendChild(grid);

    var discountBox = document.querySelector('[data-discount-code-container]');
    if (discountBox && discountBox.parentNode) {
      discountBox.parentNode.insertBefore(section, discountBox);
    } else {
      var fallback =
        document.querySelector('.seal-oneThird') ||
        document.querySelector('main') ||
        document.body;
      fallback.appendChild(section);
    }

    var mobileSection = cloneWithSync(section);
    mobileSection.classList.remove('grns-addon-section--desktop');
    mobileSection.classList.add('grns-addon-section--mobile');

    var billingSection =
      document.querySelector('[data-billing-schedule]') ||
      document.querySelector('.seal-billing-schedule') ||
      (function() {
        var els = document.querySelectorAll('h2, h3, h4, p, div');
        for (var i = 0; i < els.length; i++) {
          if (els[i].textContent.trim() === 'Billing schedule') {
            return els[i].closest('[class*="seal-"]') || els[i].parentNode;
          }
        }
        return null;
      })();

    if (billingSection && billingSection.parentNode) {
      billingSection.parentNode.insertBefore(mobileSection, billingSection);
    }

    enhance();

    var observer = new MutationObserver(function() { enhance(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 5000);

    /* Persistent protector for base sub items — keeps running for whole session
       so even if Seal re-renders or the user opens Edit later, remove controls
       on Single/Double Subscription rows stay disabled.
       Same observer also runs filterSwapModal() so the "Select product" modal
       gets filtered the moment it appears. */
    /* Force white text on Seal Save button — Seal's class is unknown/version-specific.
       Match by text content, apply inline !important to the button AND all descendants. */
    function fixSaveButtons() {
      var els = document.querySelectorAll('button, a, input[type="submit"], [role="button"]');
      for (var i = 0; i < els.length; i++) {
        var b = els[i];
        var t = ((b.value || b.textContent || '') + '').trim().toLowerCase();
        /* Match Save / Update but ignore common false-positives (Save $X off etc.) */
        if ((t === 'save' || t === 'save changes' || t === 'update' || t === 'update address' || t === 'save address') && t.length < 25) {
          b.style.setProperty('color', '#fff', 'important');
          b.style.setProperty('background', '#0E2D03', 'important');
          b.style.setProperty('border-color', '#0E2D03', 'important');
          var kids = b.querySelectorAll('*');
          for (var k = 0; k < kids.length; k++) {
            kids[k].style.setProperty('color', '#fff', 'important');
          }
        }
      }
    }

    /* 90-DAY REWARDS DISPLAY — only fires when sub is 90-day. Zero-op otherwise.
       Swaps "Loyalty - <30-day rule>" text in the "Next loyalty discount" card
       with 90-day-specific copy based on the upcoming renewal #. */
    var NINETY_DAY_MATCH = /90.?day\s+subscription/i;
    var NINETY_DAY_LABELS = {
      1: 'Renewal 1: E-Book, 10% OFF & Re-usable Straw',
      2: 'Renewal 2: Personalised Check-in, Travel Sachets & Mystery Gift',
      3: 'Renewal 3: GRNS VIP — 10% OFF Forever'
    };
    function is90DayPortal() {
      return NINETY_DAY_MATCH.test(document.body ? (document.body.textContent || '') : '');
    }
    function nintyDayCompletedRenewals() {
      var nums = document.querySelectorAll('.seal-sub-billing-num');
      var highestCompleted = 0;
      nums.forEach(function (n) {
        var row = n.closest('.seal-attempt, .seal-billing-attempt, .seal-flex, li, tr') || n.parentElement;
        if (!row) return;
        if (/scheduled/i.test(row.textContent || '')) return;
        var val = parseInt((n.textContent || '').replace(/\D/g, ''), 10);
        if (!isNaN(val) && val > highestCompleted) highestCompleted = val;
      });
      return Math.max(0, highestCompleted);
    }
    function nintyDayUpcomingLabel() {
      var upcoming = nintyDayCompletedRenewals() + 1;
      if (upcoming >= 3) return NINETY_DAY_LABELS[3];
      return NINETY_DAY_LABELS[upcoming] || NINETY_DAY_LABELS[3];
    }
    function apply90DayOverride() {
      if (!is90DayPortal()) return;
      var newLabel = nintyDayUpcomingLabel();
      var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
      var node;
      /* Match Seal's own loyalty naming ("Loyalty - …") OR our injected
         discount code titles ("GRNS 90-Day Loyalty 10%", "GRNS 90-Day VIP …")
         OR previously-swapped labels ("Renewal N: …") for re-entrancy. */
      var re = /^(Loyalty\s*[-–]|GRNS\s+90.?Day|Renewal\s+\d)/i;
      while ((node = walker.nextNode())) {
        var t = (node.nodeValue || '').trim();
        if (re.test(t)) node.nodeValue = newLabel;
      }
    }
    var protector = new MutationObserver(function() {
      protectBaseSubItems();
      filterSwapModal();
      fixSaveButtons();
      apply90DayOverride();
    });
    fixSaveButtons();
    apply90DayOverride();
    protector.observe(document.body, { childList: true, subtree: true });

    /* CANCEL CONFIRMATION FLOW — intercept Seal's "Cancel my subscription"
       first click, warn about losing rewards, offer Pause. If they confirm
       cancel anyway, let the click through so Seal's normal cancel-reason
       card renders. Non-cancel clicks unaffected. */
    var grnsCancelConfirmed = false;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t) return;
      var btn = t.closest && t.closest('[data-action="cancel_subscription"]');
      if (!btn) return;
      if (grnsCancelConfirmed) return;
      e.preventDefault();
      e.stopPropagation();
      showCancelWarning(btn);
    }, true);

    function showCancelWarning(cancelBtn) {
      if (document.querySelector('.grns-cancel-modal-overlay')) return;
      var overlay = document.createElement('div');
      overlay.className = 'grns-cancel-modal-overlay';
      var m = document.createElement('div');
      m.className = 'grns-cancel-modal';
      m.innerHTML =
        '<h3>Wait — you’ll lose your loyalty rewards</h3>' +
        '<p>Cancelling forfeits your upcoming reward and resets your progress toward VIP status. If you just need a break, you can pause instead — your rewards stay locked in for when you’re ready.</p>' +
        '<div class="grns-cancel-modal__btns">' +
          '<button type="button" class="grns-cancel-modal__btn grns-cancel-modal__btn--primary" data-grns-modal="pause">Pause my subscription instead</button>' +
          '<button type="button" class="grns-cancel-modal__btn grns-cancel-modal__btn--danger" data-grns-modal="cancel">Cancel anyway</button>' +
          '<button type="button" class="grns-cancel-modal__btn grns-cancel-modal__btn--dismiss" data-grns-modal="dismiss">Never mind</button>' +
        '</div>';
      overlay.appendChild(m);
      overlay.addEventListener('click', function (ev) {
        if (ev.target === overlay) overlay.remove();
      });
      m.addEventListener('click', function (ev) {
        var b = ev.target.closest && ev.target.closest('[data-grns-modal]');
        if (!b) return;
        var choice = b.getAttribute('data-grns-modal');
        if (choice === 'dismiss') { overlay.remove(); return; }
        if (choice === 'pause') {
          overlay.remove();
          var pauseBtn = document.querySelector('[data-action="pause_subscription"]');
          if (pauseBtn) pauseBtn.click();
          return;
        }
        if (choice === 'cancel') {
          overlay.remove();
          grnsCancelConfirmed = true;
          setTimeout(function () { cancelBtn.click(); }, 0);
        }
      });
      document.body.appendChild(overlay);
    }

    /* Click-time safety net: if anything that looks like remove/delete on a base sub row
       gets clicked anyway, swallow it. */
    document.addEventListener('click', function (e) {
      var target = e.target;
      var row = target.closest && target.closest('tr, li, [class*="item"], [class*="Item"], [class*="row"]');
      if (!row) return;
      if (!isBaseSubText(row.textContent)) return;
      var label = (target.getAttribute && (target.getAttribute('aria-label') || target.textContent || target.className) || '').toString().toLowerCase();
      var tag = target.tagName || '';
      var looksLikeRemove = label.indexOf('remove') !== -1 || label.indexOf('delete') !== -1 || label.indexOf('trash') !== -1 || (tag === 'SVG' && (target.closest('button,a,[role="button"]') || target));
      if (looksLikeRemove) {
        e.preventDefault();
        e.stopPropagation();
        alert('Your base subscription is required to keep your member pricing on add-ons. Contact support if you need to make a change.');
      }
    }, true);
  }

  document.addEventListener('sealsubs_portal:loaded', inject);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(inject, 300); });
  } else {
    setTimeout(inject, 300);
  }

  /* ================================================================
     PHONE-VALIDATION AUTO-FIX
     When Seal blocks a Save action with "Validation failed: Shipping
     address phone Enter a phone number", intercept the popup, ask the
     customer for a phone number in-place, save it via seal-proxy, then
     re-fire the last Save action. Zero effect on any other flow. */
  (function () {
    var lastSaveEl = null;
    var handling = false;

    /* Remember the most recent click on a Seal-styled Save/Update button so
       we can re-click it after the phone is saved. Only tracks clicks on
       buttons whose text is exactly "save"/"update"/"save changes". */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      /* Find the nearest clickable */
      var el = t.closest('[data-action="save"], #seal-save-button, button, div[role="button"], .seal-button');
      if (!el) return;
      var txt = ((el.textContent || '').trim()).toLowerCase();
      if (txt === 'save' || txt === 'update' || txt === 'save changes' || txt === 'update address') {
        lastSaveEl = el;
      }
    }, true);

    function findPhoneErrorPopup() {
      var candidates = document.querySelectorAll('[class*="modal" i], [class*="dialog" i], [class*="popup" i], [class*="alert" i], [role="dialog"], [role="alertdialog"], .seal-modal, .seal-dialog, .seal-alert-dialog, div');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el.hasAttribute('data-grns-phone-fix-handled')) continue;
        var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!txt || txt.length > 400) continue;
        if (!/shipping address phone/i.test(txt)) continue;
        var smaller = el.querySelector && el.querySelector('[class*="modal" i], [class*="dialog" i]');
        if (smaller && /shipping address phone/i.test((smaller.textContent || ''))) continue;
        return el;
      }
      return null;
    }

    /* Dismiss ANY lingering Seal error dialogs by clicking their OK/Okay button.
       Called repeatedly after a successful phone save to catch late-appearing
       error dialogs (Seal's async submit chain can spew multiple). */
    function dismissLingeringSealErrors() {
      var patterns = /(shipping address phone|couldn.?t save|couldn.?t update|validation failed|please try again|something went wrong|error occurred|failed to save|failed to update)/i;
      /* Two-pass: (1) look for classic dialog containers, (2) look at any
         element whose text matches and has an Okay button descendant. */
      var candidates = document.querySelectorAll('[class*="modal" i], [class*="dialog" i], [class*="popup" i], [class*="alert" i], [role="dialog"], [role="alertdialog"], .seal-modal, .seal-dialog, .seal-alert-dialog, .seal-notification');
      for (var i = 0; i < candidates.length; i++) {
        tryDismiss(candidates[i], patterns);
      }
      /* Broad fallback — any small block that contains error text + a button */
      var all = document.querySelectorAll('div');
      for (var j = 0; j < all.length; j++) {
        var el = all[j];
        var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!txt || txt.length > 300) continue;
        if (!patterns.test(txt)) continue;
        tryDismiss(el, patterns);
      }
    }
    function tryDismiss(el, patterns) {
      if (el.hasAttribute('data-grns-err-dismissed')) return;
      var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!patterns.test(txt)) return;
      var btns = el.querySelectorAll('button, [role="button"], .seal-button, .seal-notification-button, div');
      for (var b = 0; b < btns.length; b++) {
        var t = (btns[b].textContent || '').trim().toLowerCase();
        if (t === 'okay' || t === 'ok' || t === 'close' || t === 'dismiss' || t === 'got it') {
          try { btns[b].click(); el.setAttribute('data-grns-err-dismissed', '1'); } catch (e) {}
          return;
        }
      }
    }

    function normalisePhoneLocal(raw) {
      var s = String(raw || '').replace(/[^\d+]/g, '');
      if (/^\+?61[2-9]\d{8}$/.test(s)) return s;
      if (/^0[2-9]\d{8}$/.test(s)) return s;
      return '';
    }

    function showPhoneFixOverlay(errorPopup) {
      if (handling) return;
      handling = true;
      var proactive = !errorPopup;
      if (errorPopup) {
        errorPopup.setAttribute('data-grns-phone-fix-handled', '1');
        /* Dismiss Seal's own error popup so ours is the only thing visible */
        var okBtn = null;
        var candidates = errorPopup.querySelectorAll('button, [role="button"], .seal-button, div');
        for (var i = 0; i < candidates.length; i++) {
          var t = (candidates[i].textContent || '').trim().toLowerCase();
          if (t === 'okay' || t === 'ok' || t === 'close') { okBtn = candidates[i]; break; }
        }
        if (okBtn) setTimeout(function () { try { okBtn.click(); } catch (e) {} }, 50);
      }

      var overlay = document.createElement('div');
      overlay.className = 'grns-phone-fix-overlay';
      var box = document.createElement('div');
      box.className = 'grns-phone-fix-box';
      var headline = proactive ? 'Add your phone number' : 'Add your phone number to continue';
      var bodyTxt = proactive
        ? 'Your subscription is missing a phone number, which unlocks changing your renewal frequency and other edits. It’s used for delivery updates only.'
        : 'Your subscription needs a phone number before we can save this change. It’s used for delivery updates only.';
      box.innerHTML =
        '<h3>' + headline + '</h3>' +
        '<p>' + bodyTxt + '</p>' +
        '<input type="tel" inputmode="numeric" autocomplete="tel" class="grns-phone-fix-input" placeholder="0412 345 678" />' +
        '<div class="grns-phone-fix-btns">' +
          '<button type="button" class="grns-phone-fix-cancel">' + (proactive ? 'Not now' : 'Cancel') + '</button>' +
          '<button type="button" class="grns-phone-fix-save">' + (proactive ? 'Save phone' : 'Save & continue') + '</button>' +
        '</div>' +
        '<div class="grns-phone-fix-err" style="display:none"></div>';
      overlay.appendChild(box);
      document.body.appendChild(overlay);
      var input = box.querySelector('.grns-phone-fix-input');
      var err = box.querySelector('.grns-phone-fix-err');
      var saveBtn = box.querySelector('.grns-phone-fix-save');
      var cancelBtn = box.querySelector('.grns-phone-fix-cancel');
      setTimeout(function () { input.focus(); }, 100);

      function close() { overlay.remove(); handling = false; }

      cancelBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (ev) { if (ev.target === overlay) close(); });

      saveBtn.addEventListener('click', function () {
        var phone = normalisePhoneLocal(input.value);
        if (!phone) {
          err.textContent = 'Please enter a valid Australian mobile (e.g. 0412 345 678).';
          err.style.display = 'block';
          return;
        }
        var subId = getSubscriptionId();
        if (!subId) {
          err.textContent = 'Could not find your subscription. Please refresh and try again.';
          err.style.display = 'block';
          return;
        }
        saveBtn.disabled = true;
        saveBtn.textContent = 'Saving…';
        err.style.display = 'none';
        fetch(PROXY_URL + '?mode=set-phone', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ subscription_id: subId, phone: phone })
        })
          .then(function (r) { return r.json().catch(function () { return {}; }); })
          .then(function (data) {
            if (data && (data.ok || data.success)) {
              /* Phone is saved on the sub. We can't reliably re-click Save
                 because Seal's form state still has no phone and would
                 overwrite our value or fail validation again. Cleanest fix:
                 reload the page so Seal client re-fetches the sub state
                 (which now has a phone), then the customer redoes their
                 change once and it saves cleanly. */
              dismissLingeringSealErrors();
              box.innerHTML =
                '<h3 style="margin:0 0 12px;color:#0d1a06">Phone saved ✓</h3>' +
                '<p style="margin:0 0 20px;color:#335744;line-height:1.5">Reloading the page — please make your change again and tap Save. It’ll go through this time.</p>';
              setTimeout(function () { location.reload(); }, 1200);
            } else {
              saveBtn.disabled = false;
              saveBtn.textContent = 'Save & continue';
              err.textContent = 'Could not save phone: ' + (data && (data.error || data.error_message) || 'unknown error');
              err.style.display = 'block';
            }
          })
          .catch(function (e) {
            saveBtn.disabled = false;
            saveBtn.textContent = 'Save & continue';
            err.textContent = 'Network error: ' + e.message;
            err.style.display = 'block';
          });
      });
    }

    var errObserver = new MutationObserver(function () {
      if (handling) return;
      var popup = findPhoneErrorPopup();
      if (popup) showPhoneFixOverlay(popup);
    });
    errObserver.observe(document.body, { childList: true, subtree: true });

    /* Proactive on-load check — if the sub has no phone, prompt for it
       before the customer discovers Edit is missing. Runs after a small
       delay so Seal has rendered and getSubscriptionId() has a live DOM. */
    setTimeout(function () {
      if (handling) return;
      var subId = getSubscriptionId();
      if (!subId) return;
      fetch(PROXY_URL + '?mode=check-phone&id=' + encodeURIComponent(subId))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data || data.has_phone) return;
          if (handling) return;
          showPhoneFixOverlay(null);
        })
        .catch(function () {});
    }, 1500);
  })();

  /* ================================================================
     MOBILE-ONLY: Items card price column — cluster the 3 price rows
     (original, discount, total) into a tight stack at the top-right of
     the Items card. Uses inline styles to beat Seal's stylesheet.
     Runs on load + every DOM mutation. Desktop untouched. */
  (function () {
    function tighten() {
      if (window.innerWidth > 720) return;
      var container = document.getElementById('seal-subscription-items-list-container');
      if (!container) return;
      var rows = container.querySelectorAll('.seal-layout');
      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        row.style.setProperty('position', 'relative', 'important');
        /* Detect edit mode: visible input or Save/Cancel/Remove button in this row */
        var editing = !!row.querySelector('input:not([type="hidden"]), select, textarea, [contenteditable="true"]');
        if (!editing) {
          var btns = row.querySelectorAll('button, a');
          for (var b = 0; b < btns.length; b++) {
            var t = (btns[b].textContent || '').trim().toLowerCase();
            if (t === 'save' || t === 'cancel' || t === 'remove') { editing = true; break; }
          }
        }
        var cols = row.querySelectorAll('.seal-oneThird');
        for (var i = 0; i < cols.length; i++) {
          var col = cols[i];
          /* Skip cols that contain buttons/inputs — those are edit controls (Remove, Save, Cancel), not price cols */
          if (col.querySelector('button, a[role="button"], input:not([type="hidden"]), select, textarea, .seal-btn, [class*="button"]')) continue;
          if (editing) {
            /* Edit mode: let price col flow naturally BELOW the edit form */
            col.style.setProperty('position', 'static', 'important');
            col.style.setProperty('margin-top', '10px', 'important');
            col.style.setProperty('margin-right', '0', 'important');
            col.style.setProperty('margin-left', '0', 'important');
            col.style.setProperty('margin-bottom', '0', 'important');
          } else {
            /* View mode: absolute top-right, in line with item name */
            col.style.setProperty('position', 'absolute', 'important');
            col.style.setProperty('top', '6px', 'important');
            col.style.setProperty('right', '0', 'important');
            col.style.setProperty('margin', '0', 'important');
          }
          col.style.setProperty('display', 'flex', 'important');
          col.style.setProperty('flex-direction', 'column', 'important');
          col.style.setProperty('align-items', 'flex-end', 'important');
          col.style.setProperty('justify-content', 'flex-start', 'important');
          col.style.setProperty('gap', '0', 'important');
          col.style.setProperty('row-gap', '0', 'important');
          col.style.setProperty('height', 'auto', 'important');
          col.style.setProperty('min-height', '0', 'important');
          col.style.setProperty('width', 'auto', 'important');
          for (var j = 0; j < col.children.length; j++) {
            var child = col.children[j];
            if (child.classList && child.classList.contains('seal-separator')) {
              child.style.setProperty('margin', '3px 0', 'important');
              child.style.setProperty('padding', '0', 'important');
            } else {
              child.style.setProperty('margin', '0', 'important');
              child.style.setProperty('padding', '0', 'important');
              child.style.setProperty('height', 'auto', 'important');
              child.style.setProperty('min-height', '0', 'important');
            }
          }
        }
      }
    }
    tighten();
    var mo = new MutationObserver(tighten);
    mo.observe(document.body, { childList: true, subtree: true });
  })();

  /* ================================================================
     REMOVE-CLICK INTERCEPT — Seal's Remove queues line IDs to a hidden
     `deleted_items` input but only commits them on Save (which then
     silently fails). Instead: on Remove click, let Seal queue as normal,
     then immediately POST the queued IDs to our proxy (which handles
     the phone bypass), then reload. User sees the item vanish, no Save
     step required, works like Add. */
  (function () {
    var REMOVE_LINES_URL = 'https://grns-insights-hub.vercel.app/api/seal-proxy?mode=remove-lines';
    var firing = false;

    function getDeletedIds() {
      var input = document.querySelector('input[name="deleted_items"]');
      if (!input || !input.value) return [];
      var seen = {};
      var out = [];
      input.value.split(',').forEach(function (v) {
        var s = String(v).trim();
        if (!s || seen[s]) return;
        seen[s] = 1;
        out.push(s);
      });
      return out;
    }

    function isRemoveTarget(el) {
      if (!el) return false;
      /* Seal's Remove is a DIV with class seal-button-plain-red and text "Remove" */
      var host = el.closest && el.closest('.seal-button-plain-red, [data-seal-t="overview_remove_product_button"]');
      if (host) return true;
      var txt = (el.textContent || '').trim().toLowerCase();
      if (txt === 'remove' && el.children.length === 0) return true;
      return false;
    }

    function commitRemove() {
      if (firing) return;
      var ids = getDeletedIds();
      if (!ids.length) return;
      var subId = getSubscriptionId();
      if (!subId) { console.warn('[GRNS remove] no sub id'); return; }
      firing = true;
      /* Centered loading pill */
      var overlay = document.createElement('div');
      overlay.textContent = 'Removing…';
      overlay.style.cssText = 'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#19440a;color:#fff;padding:14px 28px;border-radius:12px;font-weight:600;font-size:16px;z-index:99999;box-shadow:0 6px 24px rgba(0,0,0,0.35);';
      document.body.appendChild(overlay);

      fetch(REMOVE_LINES_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subscription_id: subId, line_ids: ids })
      })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (data) {
          if (data && data.needs_phone) {
            firing = false;
            overlay.remove();
            window.alert('Please add a phone number to your subscription, then try again.');
            return;
          }
          if (data && data.ok === false && (data.error || data.errors)) {
            /* Special-case: "no items to remove" means the line was already removed
               server-side (stale IDs from a prior try). Treat as success and reload. */
            var errStr = String(data.error || data.errors || '').toLowerCase();
            if (errStr.indexOf('no items to remove') !== -1) {
              location.reload();
              return;
            }
            firing = false;
            overlay.remove();
            console.error('[GRNS remove]', data);
            window.alert('Could not remove item: ' + (data.error || 'unknown error'));
            return;
          }
          location.reload();
        })
        .catch(function (err) {
          firing = false;
          overlay.remove();
          console.error('[GRNS remove]', err);
          window.alert('Network error removing item. Please try again.');
        });
    }

    /* Listen on capture so we run before Seal's own handler finishes DOM writes */
    document.addEventListener('click', function (ev) {
      if (!isRemoveTarget(ev.target)) return;
      /* Let Seal update deleted_items input first (its handler runs on bubble). 0ms
         still yields to the event loop so Seal's bubble handler fires before commitRemove. */
      setTimeout(commitRemove, 0);
    }, true);
  })();

  /* ================================================================
     CANCELLATION REASON GATE + REASON-SPECIFIC RETENTION VIDEOS —
     Both cancel-flow buttons stay hidden until the user picks a reason;
     when they pick one, a matching retention video plays inline. */
  (function () {
    /* Map dropdown option text → retention video URL. Match is case-insensitive
       and ignores punctuation, so "I don't like the flavour" and "I dont like the flavour" both hit. */
    var REASON_VIDEOS = {
      'i have too much product':      'https://cdn.shopify.com/videos/c/o/v/b78b2cdfa3914b278544ad61849c2d39.mov',
      'i cannot afford it':           'https://cdn.shopify.com/videos/c/o/v/f3c2904af169482ba0d8a7ccd1600453.mov',
      'i want to take a break':       'https://cdn.shopify.com/videos/c/o/v/117aeb901bf640b1bb224dc18eee230c.mov',
      'i dont like the flavour':      'https://cdn.shopify.com/videos/c/o/v/e33ca714b3034f8bbd3199a79ecc6279.mov',
    };
    function normReason(s) {
      return String(s || '').trim().toLowerCase().replace(/['`’‘]/g, '').replace(/\s+/g, ' ');
    }

    function mountVideo(box, reasonText) {
      var url = REASON_VIDEOS[normReason(reasonText)];
      var existing = box.querySelector('.grns-cancel-video');
      /* No video for this reason — remove any existing video, done */
      if (!url) {
        if (existing) existing.remove();
        return;
      }
      /* Reuse container if already mounted; swap source only if reason changed */
      var container = existing;
      if (!container) {
        container = document.createElement('div');
        container.className = 'grns-cancel-video';
        /* Container is a portrait 9:16 frame centered in the modal — no letterbox */
        container.style.cssText = 'margin:14px auto 12px;border-radius:10px;overflow:hidden;box-shadow:0 4px 14px rgba(0,0,0,0.15);width:100%;max-width:min(340px,80vw);aspect-ratio:9/16;background:transparent;';
        container.innerHTML = '<video autoplay muted playsinline controls preload="auto" style="width:100%;height:100%;display:block;object-fit:cover;background:transparent;"></video>';
        /* Insert directly BEFORE the buttons container so video sits above them */
        var btnGroup = box.querySelector('#data-seal-cancellation-buttons');
        if (btnGroup && btnGroup.parentNode) {
          btnGroup.parentNode.insertBefore(container, btnGroup);
        } else {
          box.appendChild(container);
        }
      }
      var video = container.querySelector('video');
      if (video && video.getAttribute('src') !== url) {
        video.pause();
        video.setAttribute('src', url);
        video.load();
        video.play().catch(function () { /* iOS may reject muted autoplay if unattached — user will tap */ });
      }
    }

    function refreshCancelVisibility() {
      var confirmBtn = document.getElementById('seal-cancellation-flow-box-confirm');
      var stayBtn = document.getElementById('seal-cancellation-flow-box-cancel');
      if (!confirmBtn && !stayBtn) return;
      var overlay = document.getElementById('seal-cancellation-flow-overlay');
      if (!overlay || overlay.style.display === 'none') return;
      var box = document.getElementById('seal-cancellation-flow-box') || overlay;

      /* Detect user intent: reason dropdown *changed* (data flag we set) OR textarea has content */
      var textarea = box.querySelector('textarea');
      var textareaFilled = textarea && String(textarea.value || '').trim().length > 0;
      var selectChanged = box.hasAttribute('data-grns-reason-picked');

      var show = textareaFilled || selectChanged;
      if (confirmBtn) confirmBtn.style.setProperty('display', show ? 'block' : 'none', 'important');
      if (stayBtn) stayBtn.style.setProperty('display', show ? 'block' : 'none', 'important');
    }

    /* Delegate change/input listeners so they survive Seal re-rendering the modal */
    document.addEventListener('change', function (ev) {
      var box = document.getElementById('seal-cancellation-flow-box');
      if (!box || !box.contains(ev.target)) return;
      if (ev.target.tagName === 'SELECT') {
        box.setAttribute('data-grns-reason-picked', '1');
        /* Show the reason's retention video */
        var opt = ev.target.options[ev.target.selectedIndex];
        var label = opt ? opt.textContent : ev.target.value;
        mountVideo(box, label);
      }
      refreshCancelVisibility();
    }, true);

    document.addEventListener('input', function (ev) {
      var box = document.getElementById('seal-cancellation-flow-box');
      if (!box || !box.contains(ev.target)) return;
      refreshCancelVisibility();
    }, true);

    /* Reset the "picked" flag whenever the modal is opened fresh */
    var mo = new MutationObserver(function () {
      var overlay = document.getElementById('seal-cancellation-flow-overlay');
      if (!overlay) return;
      var box = document.getElementById('seal-cancellation-flow-box');
      if (!box) return;
      /* When overlay becomes visible (display: block), clear the picked flag so Cancel is hidden again */
      if (overlay.style.display && overlay.style.display !== 'none' && !box.hasAttribute('data-grns-mounted')) {
        box.setAttribute('data-grns-mounted', '1');
        box.removeAttribute('data-grns-reason-picked');
        var stale = box.querySelector('.grns-cancel-video');
        if (stale) stale.remove();
        refreshCancelVisibility();
      } else if (!overlay.style.display || overlay.style.display === 'none') {
        if (box) box.removeAttribute('data-grns-mounted');
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  })();

  /* ================================================================
     KLAVIYO EVENT TRACKING — Cancel modal funnel + pause tracking.
     Fires client-side to Klaviyo's Client Events API using our public
     company ID (V8xyQu). Events attach to the customer's profile so
     you can segment, funnel, and compare cohorts in Klaviyo Analytics. */
  (function () {
    var KLAVIYO_COMPANY_ID = 'V8xyQu';
    var KLAVIYO_EVENTS_URL = 'https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID;
    /* Reuse the module-level fetchSubInfo() so we only hit check-phone once per page load
       (upsell currency + Klaviyo attribution share the same fetch). */
    function fireEvent(name, extraProps) {
      fetchSubInfo().then(function (info) {
        info = info || {};
        var props = Object.assign({
          subscription_id: getSubscriptionId(),
          interval: info.interval || null,
          plan_name: info.plan_name || null,
        }, extraProps || {});
        /* Prefer to attach to profile via email; if missing, still fire the event to an anonymous
           profile keyed by subscription id so we don't lose the metric count. */
        var profileAttrs = info.email
          ? { email: info.email }
          : { external_id: 'sub-' + (getSubscriptionId() || 'unknown') };
        var body = {
          data: {
            type: 'event',
            attributes: {
              properties: props,
              metric: { data: { type: 'metric', attributes: { name: name } } },
              profile: { data: { type: 'profile', attributes: profileAttrs } },
            },
          },
        };
        /* keepalive lets the request complete even if the page navigates/reloads
           immediately after (which happens on Cancel confirm — Seal reloads the sub). */
        fetch(KLAVIYO_EVENTS_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Revision': '2024-10-15' },
          body: JSON.stringify(body),
          keepalive: true,
        }).catch(function (e) { console.warn('[GRNS klaviyo] event failed:', name, e); });
      });
    }
    /* Expose so other IIFEs can call it if needed */
    window.__grnsFireEvent = fireEvent;

    /* --- Cancel modal — Opened (click-based, more reliable than watching overlay style) ---
       Fires the moment the user hits "Cancel my subscription" on the portal — that's the
       definitive intent-to-cancel signal, before any modal visibility trickery. */
    var lastOpenedFireMs = 0;
    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest && ev.target.closest('#seal-unsubscribe-button');
      if (!t) return;
      /* Debounce — Seal's own handler may re-render and re-click, don't fire multiple times */
      var now = Date.now();
      if (now - lastOpenedFireMs < 3000) return;
      lastOpenedFireMs = now;
      fireEvent('GRNS Cancel Modal — Opened', {});
    }, true);
    /* Belt-and-braces: also fire on overlay becoming visible if it wasn't caught by the click.
       Uses computed style + class attribute mutation so we catch either mechanism. */
    var lastOverlayVisible = false;
    function checkOverlay() {
      var overlay = document.getElementById('seal-cancellation-flow-overlay');
      if (!overlay) return;
      var visible = getComputedStyle(overlay).display !== 'none';
      if (visible && !lastOverlayVisible) {
        var now = Date.now();
        if (now - lastOpenedFireMs >= 3000) {
          lastOpenedFireMs = now;
          fireEvent('GRNS Cancel Modal — Opened', {});
        }
      }
      lastOverlayVisible = !!visible;
    }
    var overlayMo = new MutationObserver(checkOverlay);
    overlayMo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

    /* --- Reason Selected — hook dropdown change inside the cancel modal --- */
    document.addEventListener('change', function (ev) {
      var box = document.getElementById('seal-cancellation-flow-box');
      if (!box || !box.contains(ev.target)) return;
      if (ev.target.tagName !== 'SELECT') return;
      var opt = ev.target.options[ev.target.selectedIndex];
      var reason = opt ? opt.textContent.trim() : ev.target.value;
      var VIDEO_MAPPED = ['i have too much product', 'i cannot afford it', 'i want to take a break', 'i dont like the flavour'];
      var normalized = String(reason || '').toLowerCase().replace(/['`’‘]/g, '').replace(/\s+/g, ' ').trim();
      var hasVideo = VIDEO_MAPPED.indexOf(normalized) !== -1;
      fireEvent('GRNS Cancel Modal — Reason Selected', { reason: reason, has_video: hasVideo });
    }, true);

    /* --- Stay / Cancel button clicks --- */
    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest && ev.target.closest('[id]');
      if (!t) return;
      var box = document.getElementById('seal-cancellation-flow-box');
      if (!box || !box.contains(t)) return;

      function currentReason() {
        var sel = box.querySelector('select');
        if (!sel) return null;
        var opt = sel.options[sel.selectedIndex];
        return opt ? opt.textContent.trim() : sel.value;
      }
      function ownReasonText() {
        var ta = box.querySelector('textarea');
        return ta ? String(ta.value || '').trim() : '';
      }
      var reason = currentReason();
      var video = box.querySelector('.grns-cancel-video video');
      var sawVideo = !!(video && video.currentTime > 0);

      /* Stay subscribed → fires Stayed event.
         Cancel subscription → fires Cancelled event. Uses keepalive:true (set in fireEvent's fetch)
         so the request survives Seal's page reload that follows the Cancel click. Falls back to
         Seal's "Cancelled Subscription" webhook as truth if client fetch still misses. */
      if (t.id === 'seal-cancellation-flow-box-cancel') {
        fireEvent('GRNS Cancel Modal — Stayed', { reason: reason, saw_video: sawVideo, own_reason_text: ownReasonText() });
      } else if (t.id === 'seal-cancellation-flow-box-confirm') {
        fireEvent('GRNS Cancel Modal — Cancelled', { reason: reason, saw_video: sawVideo, own_reason_text: ownReasonText() });
      }
    }, true);
  })();

  /* ================================================================
     EDIT-MODE HELPER TEXT — Shows a small hint at the top of the Items
     section whenever the customer enters edit mode, guiding them to Save
     between add and remove actions (Seal queues adds until Save, so
     trying to remove the last existing item before Save-ing an add
     hits "you can't remove all items"). */
  (function () {
    var HELPER_ID = 'grns-edit-mode-helper';

    function refreshHelper() {
      var container = document.getElementById('seal-subscription-items-list-container');
      if (!container) return;
      var inEdit = container.classList.contains('seal-editing');
      var existing = document.getElementById(HELPER_ID);

      if (!inEdit) {
        if (existing) existing.remove();
        return;
      }
      if (existing) return; /* already showing */

      var hint = document.createElement('div');
      hint.id = HELPER_ID;
      var isMobile = window.innerWidth <= 720;
      hint.style.cssText = 'padding:10px 14px;background:#f4fbf2;border:1px solid #c8e6c0;border-left:3px solid #19440a;border-radius:8px;font-size:13px;line-height:1.4;color:#19440a;font-family:inherit;';
      /* Force margins with !important so nothing overrides. Mobile: tight, no gap.
         Desktop: keeps a bit of breathing room. */
      if (isMobile) {
        hint.style.setProperty('margin-top', '-8px', 'important');
        hint.style.setProperty('margin-bottom', '-14px', 'important');
      } else {
        hint.style.setProperty('margin-top', '0', 'important');
        hint.style.setProperty('margin-bottom', '12px', 'important');
      }
      hint.innerHTML =
        '<strong>Swapping flavours or items?</strong> ' +
        'Add your new item and click <strong>Save</strong> first, then Edit again to remove the old one. ' +
        'A subscription must have at least one item at all times.';
      /* Insert BEFORE the container (as a sibling) so Seal's Save/Cancel buttons floating
         at the top of the container don't overlap the hint. */
      if (container.parentNode) {
        container.parentNode.insertBefore(hint, container);
      } else {
        container.insertBefore(hint, container.firstChild);
      }
    }

    refreshHelper();
    var mo = new MutationObserver(function () {
      if (mo._pending) return;
      mo._pending = true;
      requestAnimationFrame(function () { mo._pending = false; refreshHelper(); });
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  })();

  preloadImages();
  /* Kick off currency + discount fetch on load; repaint addon-card prices when it resolves. */
  fetchSubInfo().then(function (info) { if (info && info.currency) repaintAddonPrices(info); });
})();

















